import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {TableOfContentsService} from '../../../../services/toc/table-of-contents.service';
import {MapService} from '../../../../services/map/map.service';
import {GridService} from '../../../../services/grid/grid.service';
import {AttributeService} from '../../../../services/attribute/attribute.service';
import {DisclaimerDialogComponent} from '../disclaimer-dialog/disclaimer-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {GoogleAnalyticsService} from '../../../../services/googleAnalytics/google-analytics.service';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DropdownComponent implements OnInit {
  @Input() public node: any = {};

  public transparency = 1;
  public currentPath = '/2d-view';
  private featureLayerObj;


  constructor(private toc: TableOfContentsService, private map: MapService, private cd: ChangeDetectorRef, private dialog: MatDialog,
              private grid: GridService, private attribute: AttributeService, private ga: GoogleAnalyticsService) { }

  ngOnInit() {
    if (this.node.transparency) {    
      this.transparency = this.node.transparency;
    }
    
    const layerSvcComplete = this.toc.getlayerServiceInfoComplete().subscribe(
      (layerElem) => {
        if (layerElem != undefined && this.node != undefined && layerElem.id === this.node.id) {
          // Set label property for node after reading service layer information
          this.node.label = layerElem.label;
          this.node.minScale = layerElem.minScale;
          this.node.maxScale = layerElem.maxScale;
          this.node.isLayerInScale = layerElem.isLayerInScale;
          this.node.layerAvailable = layerElem.layerAvailable;
          this.cd.detectChanges();
        }
    });
  }

  /**
   * Show layer description
   */
  public async ShowDescription() {
    let layerDescriptionData = "No description data available for Layer: " + this.node.name;
    if (this.node.description && this.node.description.length > 0) {
      layerDescriptionData = this.node.description;
    }
    else {
      // Get layer description from rest endpoint
      if (!this.node.serviceMetadataReturned && this.node.nodeType !== 'basemap') {
        // get service metadata for layer
        const retLayerElem: any = await this.toc.getLayerServiceInfo(this.node);
        if (retLayerElem && retLayerElem.description && retLayerElem.description.length > 0) {
          layerDescriptionData = this.node.description;
        }  
      }

      if (this.node.nodeType === 'basemap' && this.node.url && this.node.url.length > 0)  {
        const urlJson = this.node.url.trim() + '?f=pjson'
        const retLayerInfo: any = await this.toc.getServiceInfo(urlJson);
        if (retLayerInfo && retLayerInfo.description && retLayerInfo.description.length > 0) {
          this.node.description = retLayerInfo.description;
          //console.log('get description from url: ' + this.node.id);
          layerDescriptionData = this.node.description;
        }  
      }
    }
    // Display description
    this.showDialog(layerDescriptionData, "text");
  }

  /**
   * User event when the opacity slider is moved
   * Updates the AGSLayer reference opacity attribute to the updated slider position
   * @param event: Material slider event
   */
  public updateOpacity(event) {
    if (event && event.value ) {
      const testLayer: any = this.node;
      if (testLayer.nodeType === 'basemap') {
        this.toc.changeBasemapTransparency(event.value);
      }
      else {
        if (testLayer.nodes) {
          for (const i of testLayer.nodes) {
            this.toc.changeLayerTransparency(i, event.value);
            if (i.nodes) {
              for (const j of i.nodes) {
                this.toc.changeLayerTransparency(j, event.value);
              }
            }
          }
        } else {
          this.toc.changeLayerTransparency(this.node, event.value);
        }
      }
    }
  }

  /**
   * Toggle layer labels on or off
   */
  public labelLayer() {
    this.toc.toggleLayerLabels(this.node);
  }

  /**
   * User event function that fires when they click on the attribute table option
   * Opens the full layer in the attribute table using the attribute service
   */
  public async openAttributeTable() {
    // Get the latest version of the AGSLayer that was selected
    const nodeSvcLayerID = this.node.serviceLayerID;
    const currLayer = this.toc.agsLayerList.findLayerInVisibleLayerListByID(nodeSvcLayerID);
    
    // Feature layer urls end with the layer id, map service layers don't
    let layerUrl = this.node.url + '/' + this.node.visibleLayersArr[0];
    if (this.node.url.trim().endsWith('/' + this.node.visibleLayersArr[0])) {
      layerUrl = this.node.url;
    }

    this.featureLayerObj = {
      url: layerUrl,
      id: this.node.id,
      title: this.node.id,
      layerDashboardInfo: this.toc.getlayerDashboardInfo(this.node)
    }
    // Turn on feature table widget to add this layers attribute table
    await this.grid.widgetOff('attributes');
    await this.grid.widgetOn('attributes');
    this.toc.featuretableObservable.next(this.featureLayerObj);
  }

  /**
   * Shows a mat dialog popup using dynamic text
   *
   * @param dialogData: Text to display
   */
  public showDialog(dialogData, type) {
    this.dialog.open(DisclaimerDialogComponent, {
      data: {message: dialogData, messageType: type}
    });
  }

  public gtag(button, layer) {
    this.ga.eventEmitter('dropdown', 'dropdown', button, layer);
  }
}
